import { Table, Space, Button, Popconfirm, Typography, Tag, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { Text } = Typography;

const formatNumber = (value) =>
  new Intl.NumberFormat("es-CO").format(Number(value || 0));

export default function EntregasTable({
  data = [],
  loading,
  pagination,
  onPageChange,
  selectedRows,
  setSelectedRows,
  onDelete,
  onEdit,
  permissionDelete,
  permissionUpdate
}) {

  const handleTableChange = (paginationInfo) => {
    onPageChange(paginationInfo.current, paginationInfo.pageSize);
  };

  const rowSelection = {
    // La paginación es en servidor: se conserva lo seleccionado en otras páginas.
    preserveSelectedRowKeys: true,
    selectedRowKeys: selectedRows.map((r) => r.oid),
    onChange: (_, selectedRowsData) => {
      setSelectedRows(selectedRowsData);
    }
  };

  const columns = [

    {
      title: "Entidad",
      width: 260,
      render: (_, record) => (
        <Space direction="vertical" size={0}>

          <Space>
            <Text strong ellipsis>
              {record.nombre_entrega}
            </Text>

            <Tag color={record.tipo_entrega_texto === "Participante" ? "blue" : "green"}>
              {record.tipo_entrega_texto}
            </Tag>
          </Space>

          <Text type="secondary">
            {record.tipo_entrega_texto === "Participante"
              ? `CC ${record.identificacion}`
              : `NIT ${record.identificacion}`}
          </Text>

        </Space>
      )
    },

    {
      title: "Producto",
      width: 350,
      render: (_, record) => (
        <Tooltip title={record.nombre_producto}>
          <Space direction="vertical" size={0}>
            <Text strong ellipsis>
              {record.nombre_producto}
            </Text>

            <Text
              type="secondary"
              style={{ fontSize: 12 }}
              ellipsis
            >
              {record.tipo_producto}
            </Text>
          </Space>
        </Tooltip>
      )
    },

    {
      title: "Cantidad",
      dataIndex: "cantidad",
      width: 100,
      align: "center",
      render: (value) => (
        <Text strong>
          {formatNumber(value)}
        </Text>
      )
    },

    {
      title: "Ubicación",
      width: 160,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Text strong>
            {record.municipio}
          </Text>

          <Text type="secondary">
            {record.departamento}
          </Text>
        </Space>
      )
    },

    {
      title: "Proyecto",
      width: 350,
      render: (_, record) => (
        <Space>
          <Tag color="blue">
            {record.codigo}
          </Tag>

          <Text
            type="secondary"
            ellipsis
          >
            {record.proyecto}
          </Text>
        </Space>
      )
    },

    {
      title: "Fecha",
      dataIndex: "fecha_entrega",
      width: 130,
      render: (value) =>
        value ? dayjs(value).format("DD MMM YYYY") : ""
    },

    {
      title: "Acciones",
      fixed: "right",
      align: "center",
      width: 100,
      render: (_, record) => (
        <Space>

          {permissionUpdate && (
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
            />
          )}

          {permissionDelete && (
            <Popconfirm
              title="Eliminar entrega"
              description="¿Seguro que deseas eliminar este registro?"
              onConfirm={() => onDelete(record)}
              okText="Sí"
              cancelText="No"
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          )}

        </Space>
      )
    }

  ];

  return (
    <Table
      rowKey="oid"
      bordered
      loading={loading}
      columns={columns}
      dataSource={data}
      rowSelection={permissionDelete ? rowSelection : undefined}
      scroll={{ x: 1200 }}
      onChange={handleTableChange}
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100],
        showTotal: (total) => `Total registros: ${total}`
      }}
    />
  );
}